
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Adenocarcinoma_lacrimal',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Adenocarcinoma_lacrimal.vue